import React from 'react';

import { VISIBILITY_ROWS, VisibilityMap, VisibilityRow, RowState, anyHidden, rowState } from './visibilityLayers';

interface VisibilityMenuProps {
  iconSrc: string;
  open: boolean;
  visibility: VisibilityMap;
  onToggleOpen: () => void;
  onRowChange: (row: VisibilityRow, shown: boolean) => void;
  onShowAll: () => void;
}

const ARIA_CHECKED: Record<RowState, 'true' | 'false' | 'mixed'> = { shown: 'true', hidden: 'false', partial: 'mixed' };

/**
 * Az eszköztár „Megjelenítés" oszlopa: a gomb egy listát nyit, soronként a Unity egy csoportjával
 * (frontok, vasalatok, gépek...). A sorok jelölője háromállapotú: a csoport rétegei mind látszanak,
 * egyik sem, vagy csak egy részük - a „Frontok" kikapcsolása a „Vasalatok" sorát részlegesre állítja,
 * mert a fogantyú és a pánt mindkettőben benne van. Részleges sorra kattintva a csoport egésze
 * megjelenik. A pötty a gombon jelzi, ha valami el van rejtve. Az állapotot a UnityView tartja
 * (a Unity `Visibility` view change-éből), ez csak megjeleníti.
 */
const VisibilityMenu: React.FC<VisibilityMenuProps> = ({ iconSrc, open, visibility, onToggleOpen, onRowChange, onShowAll }) => {
  const hidden = anyHidden(visibility);

  return (
    <div
      className={[
        'unity-overlay-toolbar__column',
        'unity-overlay-toolbar__column--dropdown',
        open ? 'unity-overlay-toolbar__column--open' : ''
      ].filter(Boolean).join(' ')}
    >
      <button
        type="button"
        className="unity-overlay-toolbar__button unity-overlay-toolbar__button--active unity-overlay-toolbar__button--dropdown"
        aria-label="Megjelenítés"
        title="Megjelenítés"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={onToggleOpen}
      >
        <img className="unity-overlay-toolbar__icon" src={iconSrc} alt="" aria-hidden="true" />
        {hidden && <span className="unity-overlay-toolbar__badge" aria-hidden="true" />}
      </button>

      <div className="unity-visibility-menu" role="menu" aria-label="Megjelenítés">
        <div className="unity-visibility-menu__title">Megjelenítés</div>
        {VISIBILITY_ROWS.map((row) => {
          const state = rowState(row, visibility);
          return (
            <button
              key={row.id}
              type="button"
              className={`unity-visibility-menu__row unity-visibility-menu__row--${state}`}
              role="menuitemcheckbox"
              aria-checked={ARIA_CHECKED[state]}
              onClick={() => onRowChange(row, state !== 'shown')}
            >
              <span className="unity-visibility-menu__box" aria-hidden="true" />
              <span>{row.label}</span>
            </button>
          );
        })}
        <button type="button" className="unity-visibility-menu__all" disabled={!hidden} onClick={onShowAll}>
          Mindent mutat
        </button>
      </div>
    </div>
  );
};

export default VisibilityMenu;
